@if(isLoading)
{
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">Indlæser data</h4>
</div>
}
@else
{
@if (templateWorkingText != '')
{
<div class="d-flex flex-column justify-content-center align-items-center w-100 vh-80">
    <div class="continuous-loader" role="status"></div>
    <h4 class="mt-2">{{ templateWorkingText }} </h4>
</div>

}
@else
{

<div class="card h-100 card-no-border mt-4 vh-80">
    <div class="card-body no-padding">
        <div class="row col-12">
            <div class="col">
                <div class="fw-bold card-title">Stamdata - skabelon baseret på {{ template.dbObjectName }}</div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="input-group">
                    <label class="mt-2">Aktiv:</label>
                    <span class="mt-2" style="width: 22px;"></span>
                    <div class="form-check form-switch mt-2">
                        <input class="form-check-input" type="checkbox" id="check1" (click)="onDisable()"
                            [(ngModel)]="template.enabled">
                    </div>

                    <label class="ms-2 mt-2">Navn: </label>
                    <div class="col-3 me-4">
                        <div class="input-group">
                            <input type="text" class="form-control ms-2" id="dbtabæe-name" [(ngModel)]="template.name">
                            <div [hidden]="errormessageForTemplatename == ''"
                                class="text-danger justify-content-center mt-2 ms-2">
                                <i class="fa-solid fa-triangle-exclamation fa-lg"
                                    [ngbTooltip]="errormessageForTemplatename"></i>
                            </div>
                        </div>
                    </div>
                    <label class="mt-2"> Beskrivelse: </label>
                    <div class="col-3 me-4">
                        <input type="text" class="form-control ms-2" id="dbtabæe-name"
                            [(ngModel)]="template.description">
                    </div>

                    <label class="mt-2 ms-4 me-4">Tilladelser: [{{ template.templatecrud }}] </label>
                    <div class="col"></div>
                    <div class="col">
                        <div class="d-flex justify-content-end">
                            <button class="btn btn-success text-end position-relative" [disabled]="anyErrors()"
                                [ngbTooltip]="isDirty() ? 'Der er ændringer, som ikke er gemt' : ''"
                                (click)="onUpdateTemplate()">
                                Opdater
                                @if (isDirty()) {
                                <span class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                                    <span class="visually-hidden">Ugemte ændringer</span>
                                </span>
                                }
                            </button>
                            <div class="ms-2"></div>
                            <button class="btn btn-primary" [disabled]="! template.enabled"
                                (click)="onShowtemplateinfo()" ngbTooltip="Vis information">
                                <i class="fa-regular fa-info"></i>
                            </button>
                            <div class="ms-2"></div>
                            <span [ngbTooltip]="template.canDelete ? '' : 'Databaseskabelonen tillader ikke sletning'">
                                <button class="btn btn-danger" [disabled]="template.enabled || !template.canDelete"
                                    (click)="onDeletetemplate()" aria-label="Slet skabelon">
                                    <i class="fa-regular fa-trash"></i>
                                </button>
                            </span>
                            <div class="ms-2"></div>
                            <button class="btn btn-primary" (click)="onGoBack()" ngbTooltip="Tilbage til liste" aria-label="Tilbage til liste">
                                <i class="fa-regular fa-arrow-left"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mt-4" />

        @if (!template.canEditFields)
        {
        <div class="alert alert-info mt-2" role="status">
            <i class="fa-regular fa-lock me-2"></i>Felterne er låst af databaseskabelonen – kun aktiv, navn og beskrivelse kan ændres.
        </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="mt-2 fw-bold card-title">Felter [{{ template.items.length }}] </div>
                <div class="table-wrap-60vh">
                    <table class="table table-striped" (input)="revalidate()" (change)="revalidate()">
                        @if(template.items.length == 0)
                        {
                        <thead class="thead-sticky">
                            <tr>
                                <th class="ms-2 no-data">Ingen felter at vise.</th>
                            </tr>
                        </thead>
                        }
                        @else
                        {
                        <thead class="thead-sticky">
                            <tr>
                                <th class="header" scope="col"> Navn </th>
                                <th class="header" scope="col"> Defaultværdi </th>
                                <th class="header" scope="col"> Skal udfyldes? <i title="Aktuel ved opret og ret." class="fa-light fa-circle-question info-icon">
                                </i></th>
                                <th class="header" scope="col"> Skal synkroniseres? </th>
                                <th class="header" scope="col"> Tilladelser <i title="Her vises de tilladelser skabelonen har for feltet. 
                                    &#013; Opret: Feltet må oprettes på nye rækker. 
                                    &#013; Opdater: Eksisterende felter kan bliver opdateret. 
                                    &#013; Læs: Eksisterende felter kan blive læst." 
                                    
                                    class="fa-light fa-circle-question info-icon">
                                </i></th>
                                <th class="header" scope="col"> </th>
                            </tr>
                        </thead>
                        }

                        <tbody>
                            <!-- For Each Template item (not system) -->
                            @for (item of template.items; track $index)
                            {
                            @if (! item.dbTableitemInfo.isSystemfield)
                            {
                            <tr>
                                <td>
                                    <div class="input-group template-input-group">
                                        <input type="text" class="form-control" [(ngModel)]="item.name" [readonly]="!template.canEditFields">

                                        <div [hidden]="item.errormessageForFieldname == ''"
                                            class="text-danger justify-content-center mt-2 ms-2">
                                            <i class="fa-solid fa-triangle-exclamation fa-lg"
                                                [ngbTooltip]="item.errormessageForFieldname"></i>
                                        </div>

                                    </div>
                                </td>
                                <td>
                                    <div class="input-group template-input-group">
                                        @if(item.mandatory)
                                        {
                                        <input type="text" class="form-control" value="(Defaultværdien er ikke relevant)" readonly>
                                        }
                                        @else if (!template.canEditFields)
                                        {
                                        <input type="text" class="form-control" [value]="item.defaultValue ?? ''" readonly>
                                        }
                                        @else if (item.dbTableitemInfo.defaultValueTypeNonSql === 'Guid' ) {
                                        <input type="text" class="form-control"
                                            [placeholder]="item.dbTableitemInfo.defaultValueTypeNonSql"
                                            [(ngModel)]="item.defaultValue">

                                        <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                            <span class="visually-hidden">Vis muligheder</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                            @if(item.dbTableitemInfo.isNullable)
                                            {
                                            <li><a class="dropdown-item"
                                                    (click)="onDefaultOption(item, 'System: Null')">System: Null</a>
                                            </li>
                                            }
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Ny Guid')">System: Ny Guid</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Tom Guid')">System: Tom Guid</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Skabelon standardværdi')">System: Skabelon standardværdi</a></li>
                                        </ul>
                                        <div [hidden]="item.errormessage == ''"
                                            class="text-danger justify-content-center mt-2 ms-2">
                                            <i class="fa-solid fa-triangle-exclamation fa-lg"
                                                [ngbTooltip]="item.errormessage"></i>
                                        </div>
                                        }
                                        @else if (item.dbTableitemInfo.dataType === 'bit') {
                                        <input type="text" class="form-control col-2"
                                            [(ngModel)]="item.defaultValue">

                                        <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                            <span class="visually-hidden">Vis muligheder</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end"> 
                                            @if(item.dbTableitemInfo.isNullable)
                                            {
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a>  </li>
                                            }
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, '0')">False (0) </a></li>
                                            <li><a class="dropdown-item"(click)="onDefaultOption(item, '1')">True (1)</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Skabelon standardværdi')">System: Skabelon standardværdi</a></li>
                                        </ul>
                                        <div [hidden]="item.errormessage == ''"
                                            class="text-danger justify-content-center mt-2 ms-2"> <i class="fa-solid fa-triangle-exclamation fa-lg" [ngbTooltip]="item.errormessage"></i>
                                        </div>

                                        }
                                        @else if (item.dbTableitemInfo.dataType === 'datetime2' ||
                                        item.dbTableitemInfo.dataType === 'datetime') {
                                        <input type="text" class="form-control col-2"
                                            [(ngModel)]="item.defaultValue">

                                        <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                            <span class="visually-hidden">Vis muligheder</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end"> 
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                            @if(item.dbTableitemInfo.isNullable)
                                            {
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a>  </li>
                                            }
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Nu')">System: Nu</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Skabelon standardværdi')">System: Skabelon standardværdi</a></li>
                                        </ul>
                                        <div [hidden]="item.errormessage == ''"
                                            class="text-danger justify-content-center mt-2 ms-2"> <i class="fa-solid fa-triangle-exclamation fa-lg" [ngbTooltip]="item.errormessage"></i>
                                        </div>
                                        }
                                        @else if (item.dbTableitemInfo.dataType === 'time') {
                                        <input type="text" class="form-control col-2" [(ngModel)]="item.defaultValue">

                                        <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                            <span class="visually-hidden">Vis muligheder</span>
                                        </button>

                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                            @if(item.dbTableitemInfo.isNullable)
                                            {
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a> </li>
                                            }
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Nu')">System: Nu</a></li> 
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Skabelon standardværdi')">System: Skabelon standardværdi</a></li>
                                        </ul>
                                        <div [hidden]="item.errormessage == ''"
                                            class="text-danger justify-content-center mt-2 ms-2">
                                            <i class="fa-solid fa-triangle-exclamation fa-lg"
                                                [ngbTooltip]="item.errormessage"></i>
                                        </div>
                                        }
                                        @else if (item.dbTableitemInfo.dataType === 'int' ||
                                        item.dbTableitemInfo.dataType === 'numeric' ||
                                        item.dbTableitemInfo.dataType === 'decimal' ) {
                                        <input type="text" class="form-control col-2"
                                            [(ngModel)]="item.defaultValue">

                                        @if(item.dbTableitemInfo.isNullable)
                                        {
                                        <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                            <span class="visually-hidden">Vis muligheder</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Skabelon standardværdi')">System: Skabelon standardværdi</a></li>
                                        </ul>
                                        }

                                        <div [hidden]="item.errormessage == ''"
                                            class="text-danger justify-content-center mt-2 ms-2">
                                            <i class="fa-solid fa-triangle-exclamation fa-lg"
                                                [ngbTooltip]="item.errormessage"></i>
                                        </div>
                                        }
                                        @else if(item.dbTableitemInfo.defaultValueTypeNonSql === 'string') {
                                        <input type="text" class="form-control col-2"
                                            [(ngModel)]="item.defaultValue">

                                        <button type="button" class="btn btn-outline-secondary dropdown-toggle"
                                            data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                            <span class="visually-hidden">Vis muligheder</span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-end">
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, '')">(indtast værdi)</a></li>
                                            @if(item.dbTableitemInfo.isNullable)
                                            {
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Null')">System: Null</a> </li>
                                            }
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Tom streng')">System: Tom streng</a></li>
                                            <li><a class="dropdown-item" (click)="onDefaultOption(item, 'System: Skabelon standardværdi')">System: Skabelon standardværdi</a></li>
                                        </ul>
                                        <div [hidden]="item.errormessage == ''"
                                            class="text-danger justify-content-center mt-2 ms-2">
                                            <i class="fa-solid fa-triangle-exclamation fa-lg"
                                                [ngbTooltip]="item.errormessage"></i>
                                        </div>
                                        }
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check mt-2">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked"
                                            [(ngModel)]="item.mandatory" [disabled]="item.dbTableitemInfo.dbMandatory || !template.canEditFields">
                                        <label class="form-check-label" for="flexCheckChecked">
                                            @if (item.dbTableitemInfo.dbMandatory == true) {
                                            Obligatorisk
                                                @if (item.dbTableitemInfo.isKey) {
                                                    <i class="fa-solid fa-key" ngbTooltip="Nøglefelt"></i>
                                                }
                                            } @else {
                                                Ja
                                            }
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-check mt-2">
                                        <input class="form-check-input" type="checkbox" value="" id="flexCheckCheckedItem"
                                            [(ngModel)]="item.synchronizeField" [checked]="item.synchronizeField" [disabled]="item.dbTableitemInfo.dbMandatory || !template.canEditFields">
                                    </div>
                                </td>
                                <td>
                                    <div class="mt-2"> {{ item.itemcrud }} </div>
                                </td>
                                <td>
                                    <div class="mt-2 text-center"><i
                                            [class]="item.showDbInfo ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right'"
                                            (click)="item.showDbInfo = !item.showDbInfo"></i> </div>
                                </td>
                            </tr>
                            <tr [hidden]="item.showDbInfo">
                                <td>
                                    <span class="ms-2">Originalt navn: </span><span class=" fw-bold">{{
                                        item.dbTableitemInfo.name }}</span>
                                </td>
                                <td colspan="4">
                                    <div class="ms-2">
                                        <span>Datatype: </span><span class="fw-bold">{{
                                            item.dbTableitemInfo.defaultValueTypeNonSql }} </span>
                                        <span
                                            [hidden]="item.dbTableitemInfo.maxLength == null || item.dbTableitemInfo.maxLength == 0">
                                            <span> Maks.længde: </span><span class="fw-bold"> 
                                                @if (item.dbTableitemInfo.maxLength == -1) {
                                                Ubegrænset
                                                } @else {
                                                    {{ item.dbTableitemInfo.maxLength }} 
                                                }
                                            </span> </span>
                                        <span> Defaultværdi: </span><span class="fw-bold">
                                            @if ( item.dbTableitemInfo.defaultValueTypeNonSql == 'bool' ) {
                                                @if (item.dbTableitemInfo.defaultValue == '1') {
                                                    Sand (1)
                                                } @else if (item.dbTableitemInfo.defaultValue == '0') { 
                                                    Falsk (0)                                        
                                                } @else {
                                                    {{ item.dbTableitemInfo.defaultValue }}
                                                }
                                            } @else {
                                                {{ item.dbTableitemInfo.defaultValue }}
                                            }
                                            </span>
                                    </div>
                                </td>
                            </tr>
                            }
                            }
                        </tbody>
                    </table>
                    @if (readableSystemFields.length > 0)
                    {
                        <div class="mt-2 ms-2 fw-bold">Læsbar systemfelter: [{{ readableSystemFields.length }}] </div>
                        <table class="table table-striped">
                            <thead class="thead-sticky">
                                <tr>
                                    <th class="header" scope="col"> Navn </th>
                                    <th class="header" scope="col"> Datatype</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- For Each Template item (system) -->
                                @for (item of readableSystemFields; track $index)
                                {
                                    <tr>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.dbTableitemInfo.defaultValueTypeNonSql }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
}
}